// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__Zb+ip"};